<template>
  <div class="progress-bar">
    <div
      class="progress-bar__fill"
      :style="{ width: `${progress}%`, backgroundColor: accentColor }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
    accentColor: {
      type: String,
      default: "#4caf50",
    },
  },
};
</script>

<style scoped>
.progress-bar {
  width: 100%;
  height: 5px;
  background-color: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
}
.progress-bar__fill {
  height: 100%;
  transition: width 0.3s ease;
}
</style>
